// extracted by mini-css-extract-plugin
export default {"control":"Control_control__53ixS","button":"Control_button__Cmlhp"};